export default {
  profile: (state, getters) => (getters.isLoggedIn ? state.profile : {}),
  addresses: state => state.addresses,
  isLoggedIn: state => !!state.token && state.token !== 'undefined',
  isNewClient: state => state.profile.activityStatus === 'new',
  isOldClient: state => state.profile.activityStatus === 'old',
  token: state => state.token,
  unauthorizedImtData: state => state.unauthorizedImtData,
  preloadedMenus: state => state.preloadedMenus,
}
